export default __webpack_public_path__ + "static/media/image15.64855d67.jpg";